/* eslint-disable react/prop-types */
import React from 'react';
import {
  RideGlCoverageSolid,
  RideGlHospitalSolid,
  RideGlClockSolid,
  RideGlInsuranceSolid,
  RideGlBillSolid,
  RideGlDocumentSolid,
  RideGlCalendarSolid,
  RideGlHeartSolid,
  RideGlHospitalAttentionSolid,
  RideGlAmbulanceSolid,
  RideGlHospitalizationSolid,
  RideGlDentistSolid,
  RideGlUserSolid,
  RideGlPhoneSolid,
  RideGlTelephoneSolid,
  RideGlWhatsappSolid,
  RideGlShieldSolid,
  RideGlFamilySolid,
  RideGlStarSolid,
  RideGlPinSolid,
  RideGlMedicalAttentionOutline,
  RideGlLaptopOutline,
  RideGlCoinsOutline,
  RideGlHospitalAttentionOutline,
  RideGlHospitalOutline,
  RideGlAmbulanceOutline,
  RideGlHospitalizationOutline,
  RideGlDentistOutline,
  RideIcAmbulanceLight,
  RideIcMedicineLight,
  RideIcCompleteHealthLight,
  RideIcLiveClassLight,
  RideGlMedicalAttentionSolid,
  RideGlHealthSolid,
} from '@rimac-seguros/ride-system-components';

const ICONS = {
  RideGlCoverageSolid,
  RideGlHospitalSolid,
  RideGlClockSolid,
  RideGlInsuranceSolid,
  RideGlBillSolid,
  RideGlDocumentSolid,
  RideGlCalendarSolid,
  RideGlHeartSolid,
  RideGlHospitalAttentionSolid,
  RideGlAmbulanceSolid,
  RideGlHospitalizationSolid,
  RideGlDentistSolid,
  RideGlUserSolid,
  RideGlPhoneSolid,
  RideGlTelephoneSolid,
  RideGlWhatsappSolid,
  RideGlShieldSolid,
  RideGlFamilySolid,
  RideGlStarSolid,
  RideGlPinSolid,
  RideGlMedicalAttentionOutline,
  RideGlLaptopOutline,
  RideGlCoinsOutline,
  RideGlHospitalAttentionOutline,
  RideGlHospitalOutline,
  RideGlAmbulanceOutline,
  RideGlHospitalizationOutline,
  RideGlDentistOutline,
  RideIcAmbulanceLight,
  RideIcMedicineLight,
  RideIcCompleteHealthLight,
  RideIcLiveClassLight,
  RideGlMedicalAttentionSolid,
  RideGlHealthSolid,
};

const DynamicIcon = ({ icon, size = 'medium' }) => {
  const IconComponent = ICONS[icon];
  return IconComponent ? <IconComponent size={size} /> : null;
};

export default DynamicIcon;
